import { createI18n } from 'vue-i18n'

// Import des traductions locales (fallback)
import en from '@/locales/en.json'
import fr from '@/locales/fr.json'
import it from '@/locales/it.json'

// Types pour TypeScript
export type MessageLanguages = 'fr' | 'en' | 'it'
export type MessageSchema = typeof fr

// Configuration des langues supportées
export const SUPPORTED_LANGUAGES = [
  { code: 'fr', name: 'Français', flag: '🇫🇷' },
  { code: 'en', name: 'English', flag: '🇬🇧' },
  { code: 'it', name: 'Italiano', flag: '🇮🇹' },
] as const

// Langue par défaut (français)
export const DEFAULT_LANGUAGE: MessageLanguages = 'fr'

// Récupération de la langue sauvegardée ou détection navigateur
function getInitialLanguage(): MessageLanguages {
  // 1. Langue sauvegardée dans localStorage
  const savedLanguage = localStorage.getItem('bdc-language') as MessageLanguages
  if (savedLanguage && SUPPORTED_LANGUAGES.some(lang => lang.code === savedLanguage)) {
    return savedLanguage
  }

  // 2. Détection langue navigateur
  const browserLanguage = navigator.language.split('-')[0] as MessageLanguages
  if (SUPPORTED_LANGUAGES.some(lang => lang.code === browserLanguage)) {
    return browserLanguage
  }

  // 3. Fallback vers langue par défaut
  return DEFAULT_LANGUAGE
}

// Messages locaux (utilisés comme fallback)
const messages = {
  fr,
  en,
  it,
}

// Configuration Vue i18n
export const i18n = createI18n<[MessageSchema], MessageLanguages>({
  legacy: false, // Utiliser Composition API
  locale: getInitialLanguage(),
  fallbackLocale: DEFAULT_LANGUAGE,
  messages,
  globalInjection: true, // Permet d'utiliser $t dans les templates
  missingWarn: true, // Avertir si traduction manquante
  fallbackWarn: true, // Avertir si fallback utilisé
  warnHtmlMessage: false, // Désactive les warnings HTML (sécurisé car HTML contrôlé dans les fichiers de traduction)
})
